export default __webpack_public_path__ + "static/media/corner-right-down.794c4813.svg";